// Client-side mirror of server/utils/sessionPolicy.js role logic.
// The server is authoritative — these only drive what UI to show.

export const getRole = (session, uid) => {
  if (!session || !uid) return 'guest';
  if (session.hostId === uid) return 'host';
  const participant = session.participants?.[uid];
  if (!participant) return 'guest';
  if (participant.isHost) return 'host';
  if (participant.role === 'cohost') return 'cohost';
  return 'guest';
};

export const isHost = (session, uid) => getRole(session, uid) === 'host';

// Host or co-host: can approve/reject suggestions and work the queue
export const canManageQueue = (session, uid) => {
  const role = getRole(session, uid);
  return role === 'host' || role === 'cohost';
};

// Whose songs skip the approval gate entirely
export const canAddDirect = (session, uid) =>
  canManageQueue(session, uid) || session?.settings?.requireApproval === false;

export const sessionSettings = (session) => ({
  requireApproval: true,
  explicitAllowed: true,
  blockedArtists: [],
  genreRestrictions: [],
  chatEnabled: true,
  dmsEnabled: true,
  photosEnabled: true,
  allowGuestVoting: true,
  ...(session?.settings || {})
});
